import getRandomItem from './../util/getRandomItem';
import subjects from 'tables/subjects/data';

export default function randomSubject (type, gender) {
    const filteredSubjects = subjects
        .filter((subject) => {
            return (
                subject.types.includes(type) &&
                subject.genders.includes(gender)
            );
        });

    const subject = getRandomItem(filteredSubjects);
    return subject;
}


/** WEBPACK FOOTER **
 ** ./generator/randomPhrase/randomSubject.js
 **/